/*jslint browser */
/*global process */

import Cookie from "../../utils/cookie";
import Price from "../../utils/price";
import IdGenerator from "../../utils/id.generator";
import StorageProduct from "../../entity/storage.product";

declare var xtAjaxurl: string;
declare var window: any;
declare var document: any;
declare var sessionStorage: any;

/**
 *
 */
export default class Storage
{
    private _locale: string = 'pl-PL';
    private _currency: string = 'PLN';
    private _cookie: Cookie;
    private _storageItems: JQuery;
    private _buttonIconQtyStorage: JQuery;
    private _storageTable: JQuery;
    private _deleteStorageRowButton: JQuery;
    private _makeStoragePdf: JQuery;
    private _tempSubmitButtonText: string;
    private _pdfGeneratorMessage: JQuery;
    private _emptyStorage: JQuery;
    private _productId: number;

    constructor() {
        this._cookie = new Cookie();
        this._storageItems = $('.storage-items');
    }

    public init(): void {
        this._storageItems.append('<center><div class="storage-content" style="width: 20px; display: block; position: relative"><span class="button-icon-qty-storage">0</span><div class="dropdown-content"><div class="storage-table-content"><table class="storage-table"></table><div class="generate-pdf-container"></div></div><div class="storage-footer"><button class="make-storage-pdf wp-element-button button" type="button">Generuj <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="red" width="15px"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H296 272 184 160c-35.3 0-64 28.7-64 64v80 48 16H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM160 352h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm24 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48h8zm88-80h24c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm24 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16h-8v96h8zm72-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"/></svg></button> <button class="empty-storage wp-element-button button" type="button">Opróżnij</button><br/><span class="pdf-generator-message"></span></div></div></div></div></center>');
        this._emptyStorage = $('.empty-storage');
        this._buttonIconQtyStorage = $('.button-icon-qty-storage');
        this._storageTable = $('.storage-table');
        this._makeStoragePdf = $('.make-storage-pdf');
        this._pdfGeneratorMessage = $('.pdf-generator-message');

        this._makeStoragePdf.on('click', (e) => {
            this.makeStoragePdfClick();
        })

        this._emptyStorage.on('click', (e) => {
            this.emptyStorageClick();
        })

        this.showContent();
    }

    public registerExtraActions(): void {
        this._deleteStorageRowButton = $('.delete-storage-row-button');

        this._deleteStorageRowButton.on('click', (e) => {
            this.deleteStorageRowButtonClick($(e.currentTarget));
        })
    }

    public setMainProductId(id: number) {
        this._productId = id;
    }

    public addProduct(inputData: JQuery): void {
        const storageProduct = new StorageProduct();
        storageProduct.id = inputData.data('product');
        storageProduct.variation = inputData.data('variation');
        storageProduct.price = parseFloat(inputData.attr('data-price'));
        storageProduct.name = inputData.data('name');
        const idGenerator = new IdGenerator();
        storageProduct.uniqueKey = idGenerator.generate();
        if(inputData.attr('data-image').includes("base64")) {
            this.saveGeneratedImage(storageProduct.uniqueKey);
        }
        storageProduct.imageUrl = inputData.attr('data-image');
        storageProduct.setPrice = parseFloat(inputData.attr('data-sum-price'));
        storageProduct.quantity = parseInt(inputData.attr('data-quantity'));
        storageProduct.url = inputData.data('url');

        let accessories: any = [];
        const accessoriesData = inputData.attr('data-accessory');
        if(accessoriesData) {
            const accessoriesObjects = JSON.parse(accessoriesData);
            for(const [key, accessory] of Object.entries(accessoriesObjects)) {
                const accessoryStorage = new StorageProduct();
                const accessoryDataObject = $('.data-accessory-' + accessory);
                accessoryStorage.id = accessory as number;
                accessoryStorage.name = accessoryDataObject.data('name');
                accessoryStorage.imageUrl = accessoryDataObject.data('image');
                accessoryStorage.price = parseFloat(accessoryDataObject.data('price'));

                accessories.push(accessoryStorage);
            }
            storageProduct.accessories = accessories;
        }

        let items: any = [];
        const itemsData = inputData.attr('data-items');
        if(itemsData) {
            const itemsObjects = JSON.parse(itemsData);
            for(const [key, item] of Object.entries(itemsObjects)) {
                const itemsStorage = new StorageProduct();
                const itemDataObject = $('.configurator-item-' + item);
                itemsStorage.id = item as number;
                itemsStorage.name = itemDataObject.data('name');
                //itemsStorage.imageUrl = itemDataObject.data('image');
                itemsStorage.price = parseFloat(itemDataObject.data('price'));
                itemsStorage.label = itemDataObject.data('label');

                items.push(itemsStorage);
            }
            storageProduct.items = items;
        }

        this.setProductCookie(storageProduct);
        this.showContent();
    }

    private saveGeneratedImage(imgKey: string): void {
        const img64 = sessionStorage.getItem('current_created_img');
        const ajaxData = {
            'action': 'main_ajax',
            'controller': 'AjaxController',
            'run': 'saveGeneratedImage',
            'img': img64,
            'productId': 0,
            'imgKey': imgKey
        }

        $('.storages_custom_images').append('<img class="img_'+imgKey+'" src="'+img64+'" data-img="'+img64+'" hidden>');

        $.post(xtAjaxurl, ajaxData, function(response) {

        });
    }

    private deleteStorageRowButtonClick(ob: JQuery): void {
        this.deleteStorageRow(ob.data('key'));
    }

    private deleteStorageRow(key: string): void {
        let storage = this._cookie.getCookie('storage_product');
        if(storage) {
            let storageData = JSON.parse(storage);
            for(const [arrayKey, product] of Object.entries(storageData)) {
                const ob: any = product;
                if(ob._uniqueKey == key) {
                    storageData.splice(arrayKey, 1);
                    this.setCookie(storageData);
                    this.showContent();
                    if(ob._imageUrl.includes("base64")) {
                        this.removeImageFromDatabase(ob._uniqueKey);
                    }
                }
            }
        }
    }

    private removeImageFromDatabase(uniqueKey: string): void {
        const ajaxData = {
            'action': 'main_ajax',
            'controller': 'AjaxController',
            'run': 'removeImageFromDatabase',
            'imgKey': uniqueKey
        }

        $.post(xtAjaxurl, ajaxData, function(response) {

        });
    }

    private setProductCookie(product: StorageProduct): void {
        let object: any = [];
        const storage = this._cookie.getCookie('storage_product');
        if(storage) {
            object = JSON.parse(storage);
        }
        object.push(product);

        if(object.length > 10) {
            object.shift();
        }

        this.setCookie(object);
    }

    private setCookie(object: any) {
        const json = JSON.stringify(object);
        this._cookie.setCookie('storage_product', json, 7);
    }

    private showContent(): void
    {
        let storage = this._cookie.getCookie('storage_product');
        if(storage) {
            let storageData = JSON.parse(storage);
            this.setStorageQuantityAndEnableDisableGeneratorButton(storageData.length);
            this.renderStorageTable(storageData);
        } else {
            this.setStorageQuantityAndEnableDisableGeneratorButton(0);
        }
    }

    private setStorageQuantityAndEnableDisableGeneratorButton(number: number) {
        this._buttonIconQtyStorage.text(number);

        if(number > 0) {
            this._makeStoragePdf.prop('disabled', false);
            this._emptyStorage.prop('disabled', false);
        } else{
            this._makeStoragePdf.prop('disabled', true);
            this._emptyStorage.prop('disabled', true);
        }
    }

    private renderStorageTable(storage: Array<any>)
    {
        const price = new Price();
        let rows = '';

        if(storage.length > 0) {
            rows += '<thead><tr><th>Nazwa</th><th>Ilość</th><th>Cena</th><th>Opcje</th></tr></thead>';
        }

        rows += '<tbody class="storage-main-row">';

        for(const [key, product] of Object.entries(storage)) {
            let accessories = '';
            if(product._accessories && product._accessories.length > 0) {
                for(const [key, accessory] of Object.entries(product._accessories)) {
                    const accessoryData: any = accessory;
                    accessories += '<li>'+accessoryData._name+' (' + price.getFormated(accessoryData._price) + ')</li>';
                }
            }

            let items = '';
            if(product._items && product._items.length > 0) {
                for(const [key, item] of Object.entries(product._items)) {
                    const itemData: any = item;
                    items += '<li>'+itemData._label+': '+itemData._name+' (' + price.getFormated(itemData._price) + ')</li>';
                }
            }

            if(product._imageUrl.includes("base64")) {
                if($('.img_' + product._uniqueKey)) {
                    product._imageUrl = $('.img_' + product._uniqueKey).data('img');
                } else {
                    product._imageUrl = '';
                }
            }

            let priceString = '';
            if(product._price != null && product._price != '') {
                priceString = '(' + price.getFormated(parseFloat(product._price)) + ')';
            }

            let sumPriceString = '';
            if(product._price != null && product._price != '' && product._setPrice != '' && product._setPrice != null) {
                sumPriceString = price.getFormated(parseFloat(product._setPrice));
            }

            rows += '<tr class="storage-row-' + product._uniqueKey + '"><td class="storage-name-cell"><div><img src="' + product._imageUrl + '" class="storage-product-image" alt=""> <a href="' + product._url + '" target="_blank">' + product._name + ' ' + priceString + '</a></div><div><ul>'+items+'</ul><ul>'+accessories+'</ul></div></td><td>' + product._quantity + '</td><td>' + sumPriceString + '</td><td><span class="delete-storage-row-button" data-key="' + product._uniqueKey + '"><span class="dashicons dashicons-trash"></span></span></td></tr>';
        }

        rows += '</tbody>';

        this._storageTable.html(rows);
        this.registerExtraActions();
    }

    public makeStoragePdfClick(): void {
        const ajaxData = {
            'action': 'main_ajax',
            'controller': 'AjaxController',
            'run': 'generateStoragePdf',
        }

        const storage = this;
        this.blockButton();
        $.post(xtAjaxurl, ajaxData, function(response) {
            storage.releaseButton();
            storage.saveToDisk(response.link, storage.generateFileName());
        });
    }

    public blockButton(): void
    {
        //this._tempSubmitButtonText = this._makeStoragePdf.text();
        this._pdfGeneratorMessage.text('Generowanie...');
        this._makeStoragePdf.prop('disabled', true);
    }

    public releaseButton(): void
    {
        //this._makeStoragePdf.text(this._tempSubmitButtonText);
        this._pdfGeneratorMessage.text('');
        this._makeStoragePdf.prop('disabled', false);
    }

    public saveToDisk(fileURL: any, fileName: any): void {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            // @ts-ignore
            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }

        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    }

    private generateFileName(): string {
        const today = new Date();
        const date = today.getFullYear()+'_'+(today.getMonth()+1)+'_'+today.getDate();
        const time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
        const dateTime = date+'_'+time;

        return dateTime + '_products';
    }

    private emptyStorageClick(): void {
        this.emptyStorage();
    }

    private emptyStorage(): void {
        this._cookie.deleteCookie('storage_product');
        //this.showContent();
        this.setStorageQuantityAndEnableDisableGeneratorButton(0);
        this._storageTable.html('');
    }
}